import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'formatDate'})
export class FormatDatePipe implements PipeTransform {
    transform(value: any) {
        if(value == null) {
            return null;
        }
        return  ("0" + value.getHours()).slice(-2) + ":" + ("0" + value.getMinutes()).slice(-2) + " " +
                value.getFullYear() + "-" + ("0"+(value.getMonth()+1)).slice(-2) + "-" + ("0" + value.getDate()).slice(-2);
    }
}
